import React from "react"

const Image = ({ style, src, alt }) => (
  <img loading="lazy" style={style} src={`${src}?resize=375,250`} alt={alt} />
);
export default Image
